import {
  Maybe,
  VerticalID,
  Args,
  Operation,
} from '../../../__generated__/globalTypes'

import createUserLoginLinkString from '../CreateUserLoginLink.graphql'

export type CreateUserLoginLinkData = {
  createUserLoginLink: {
    link: Maybe<string>
  }
}

export type CreateUserLoginLinkVariables = {
  verticalId: VerticalID
  queryParams: Args
}

export type CreateUserLoginLink = Operation<
  CreateUserLoginLinkData,
  CreateUserLoginLinkVariables
>

export const CreateUserLoginLink = ({
  verticalId,
  queryParams,
}: CreateUserLoginLinkVariables): CreateUserLoginLink => ({
  query: createUserLoginLinkString,
  variables: {
    verticalId,
    queryParams: Args(queryParams),
  },
})
